import React from 'react';
import { Tag } from 'primereact/tag';

interface DocumentNameCellProps {
    rowData: any;
    onClick: () => void;
    title?: string;
}

const isPriorityEnabled = (value: any) => value === 'Y' || value === true;

export const DocumentNameCell: React.FC<DocumentNameCellProps> = ({
    rowData,
    onClick,
    title = 'Xem chi tiết'
}) => {
    const isUrgent = isPriorityEnabled(rowData.isUrgent);
    const isImportant = isPriorityEnabled(rowData.isImportant);

    return (
        <div className="flex flex-column align-items-start gap-2">
            <span
                className="underline text-primary cursor-pointer"
                onClick={onClick}
                title={title}
            >
                {rowData.agreementName}
            </span>
            {(isUrgent || isImportant) && (
                <div className="flex align-items-center gap-1 flex-wrap">
                    {isUrgent && (
                        <Tag
                            value="Khẩn cấp"
                            severity="danger"
                            icon="pi pi-bolt"
                            className="text-xs"
                        />
                    )}
                    {isImportant && (
                        <Tag
                            value="Quan trọng"
                            severity="warning"
                            icon="pi pi-bookmark-fill"
                            className="text-xs"
                        />
                    )}
                </div>
            )}
        </div>
    );
};
